import type { GridShapesMenu, Shape } from "~/types/grid.types";
import { CIRCLES_FREEFORM_SHAPES } from "./shapesCirclesFreeform";
import { ENGRAVED_1X1_FREEFORM_SHAPES } from "./shapesEngraved1x1Freeform";
import { ENGRAVED_2X2_FREEFORM_SHAPES } from "./shapesEngraved2x2Freeform";
import { HEX_DIAMOND_TRIANGLE_FREEFORM_SHAPES } from "./shapesHexDiamondTriangleFreeform";
import { PEAK_FREEFORM_SHAPES } from "./shapesPeakFreeform";
import { PRINTED_FREEFORM_SHAPES } from "./shapesPrintedFreeform";
import { SHAPE_IDS } from "./shapesIdsFreeform";
import { WOOD_SLAT_FREEFORM_SHAPES } from "./woodSlats";

export { SHAPE_IDS };

const BASIC_SHAPES: Shape[] = [
  {
    type: "rect",
    id: SHAPE_IDS.LARGE_SQUARE,
    icon: "LargeSquare",
    prefix: "LargeSquare",
    label: "Large Square",
    w: 240,
    h: 240,
  },
  {
    type: "rect",
    id: SHAPE_IDS.LARGE_HALF_LAP_HORIZONTAL,
    icon: "LargeHalflapHorizontal",
    prefix: "LargeHalflap",
    label: "Large Halflap Horizontal",
    w: 240,
    h: 120,
    children: [
      {
        type: "rect",
        id: SHAPE_IDS.LARGE_HALF_LAP_VERTICAL,
        icon: "LargeHalflapVertical",
        prefix: "LargeHalflap",
        label: "Large Halflap",
        w: 120,
        h: 240,
      },
    ],
  },
  {
    type: "rect",
    id: SHAPE_IDS.SQUARE,
    icon: "Square",
    prefix: "Blank",
    label: "Square",
    w: 120,
    h: 120,
    menuAlign: "right",
    children: [
      {
        type: "rect",
        id: SHAPE_IDS.ENGRAVED_BACK_SLASH,
        icon: "EngravedBackSlash",
        prefix: "Slash",
        label: "Slash",
        w: 120,
        h: 120,
        rotation: 0,
      },
      {
        type: "rect",
        id: SHAPE_IDS.ENGRAVED_FORWARD_SLASH,
        icon: "EngravedBackSlash",
        prefix: "Slash",
        label: "Forward Slash",
        w: 120,
        h: 120,
        rotation: 90,
      },
      {
        type: "rect",
        id: SHAPE_IDS.ENGRAVED_CROSS,
        icon: "EngravedCross",
        prefix: "Cross",
        label: "Cross",
        w: 120,
        h: 120,
      },
      {
        type: "rect",
        id: SHAPE_IDS.ENGRAVED_FOUR_SQUARE,
        icon: "EngravedFourSquare",
        prefix: "4Square",
        label: "Four Square",
        w: 120,
        h: 120,
      },
      {
        type: "rect",
        id: SHAPE_IDS.ENGRAVED_PARALLEL,
        icon: "EngravedParallel",
        prefix: "Parallel",
        label: "Parallel",
        w: 120,
        h: 120,
        rotation: 0,
      },
      {
        type: "rect",
        id: SHAPE_IDS.ENGRAVED_PARALLEL_VERTICAL,
        icon: "EngravedParallel",
        prefix: "Parallel",
        label: "Parallel Vertical",
        w: 120,
        h: 120,
        rotation: 90,
      },
    ],
  },
  {
    type: "rect-triangle",
    id: SHAPE_IDS.LEFT_BOTTOM_TRIANGLE,
    icon: "RightTopTriangle",
    prefix: "Triangle",
    label: "Triangle",
    rotation: 180,
    w: 120,
    h: 120,
    children: [
      {
        type: "rect-triangle",
        id: SHAPE_IDS.RIGHT_TOP_TRIANGLE,
        icon: "RightTopTriangle",
        prefix: "Triangle",
        label: "Right Top Triangle",
        rotation: 0,
        w: 120,
        h: 120,
      },
      {
        type: "rect-triangle",
        id: SHAPE_IDS.LEFT_TOP_TRIANGLE,
        icon: "RightTopTriangle",
        prefix: "Triangle",
        label: "Left Top Triangle",
        rotation: 270,
        w: 120,
        h: 120,
      },
      {
        type: "rect-triangle",
        id: SHAPE_IDS.RIGHT_BOTTOM_TRIANGLE,
        icon: "RightTopTriangle",
        prefix: "Triangle",
        label: "Right Bottom Triangle",
        rotation: 90,
        w: 120,
        h: 120,
      },
    ],
  },
  {
    type: "rect-triangle",
    id: SHAPE_IDS.SMALL_90_LEFT_BOTTOM_TRIANGLE,
    icon: "RightTopTriangle",
    prefix: "Small90Triangle",
    imgRotation: 270,
    
    label: "Small 90 Triangle",
    rotation: 180,
    w: 60,
    h: 60,
    children: [
      {
        type: "rect-triangle",
        id: SHAPE_IDS.SMALL_90_RIGHT_TOP_TRIANGLE,
        icon: "RightTopTriangle",
        prefix: "Small90Triangle",
        imgRotation: 270,
        
        label: "Small 90 Right Top Triangle",
        rotation: 0,
        w: 60,
        h: 60,
      },
      {
        type: "rect-triangle",
        id: SHAPE_IDS.SMALL_90_LEFT_TOP_TRIANGLE,
        icon: "RightTopTriangle",
        prefix: "Small90Triangle",
        imgRotation: 270,
        
        label: "Small 90 Left Top Triangle",
        rotation: 270,
        w: 60,
        h: 60,
      },
      {
        type: "rect-triangle",
        id: SHAPE_IDS.SMALL_90_RIGHT_BOTTOM_TRIANGLE,
        icon: "RightTopTriangle",
        prefix: "Small90Triangle",
        imgRotation: 270,
        
        label: "Small 90 Right Bottom Triangle",
        rotation: 90,
        w: 60,
        h: 60,
      },
    ],
  },
  {
    type: "rect",
    id: SHAPE_IDS.QUARTER,
    icon: "Quarter",
    prefix: "Quarter",
    label: "Quarter",
    w: 60,
    h: 60,
  },
  {
    type: "rect",
    id: SHAPE_IDS.PIXEL,
    icon: "Pixel",
    prefix: "Pixel",
    label: "Pixel",
    w: 30,
    h: 30,
  },
  {
    type: "rect",
    id: SHAPE_IDS.HALF_LAP_HORIZONTAL,
    icon: "HalflapHorizontal",
    prefix: "Half",
    label: "Halflap Horizontal",
    w: 120,
    h: 60,
    children: [
      {
        type: "rect",
        id: SHAPE_IDS.HALF_LAP_VERTICAL,
        icon: "HalflapVertical",
        prefix: "Half",
        label: "Halflap",
        w: 60,
        h: 120,
      },
    ],
  },
  {
    type: "rect",
    id: SHAPE_IDS.SHIPLAP_HORIZONTAL,
    icon: "ShiplapHorizontal",
    prefix: "Shiplap",
    label: "Shiplap Horizontal",
    w: 240,
    h: 60,
    children: [
      {
        type: "rect",
        id: SHAPE_IDS.SHIPLAP_VERTICAL,
        icon: "ShiplapHorizontal",
        prefix: "Shiplap",
        label: "Shiplap",
        w: 240,
        h: 60,
        rotation: 90,
      },
    ],
  },
  {
    type: "rect",
    id: SHAPE_IDS.MINI_SHIPLAP_HORIZONTAL,
    icon: "MiniShiplapHorizontal",
    prefix: "MiniShiplap",
    label: "Mini Shiplap Horizontal",
    w: 120,
    h: 30,
    children: [
      {
        type: "rect",
        id: SHAPE_IDS.MINI_SHIPLAP_VERTICAL,
        icon: "MiniShiplapHorizontal",
        prefix: "MiniShiplap",
        label: "Mini Shiplap",
        w: 120,
        h: 30,
        rotation: 90,
      },
    ],
  },
];

export const SHAPES: Shape[] = [
  ...BASIC_SHAPES,
  ...HEX_DIAMOND_TRIANGLE_FREEFORM_SHAPES,
  ...CIRCLES_FREEFORM_SHAPES,
  ...ENGRAVED_1X1_FREEFORM_SHAPES,
  ...ENGRAVED_2X2_FREEFORM_SHAPES,
  ...PRINTED_FREEFORM_SHAPES,
  ...PEAK_FREEFORM_SHAPES,
  ...WOOD_SLAT_FREEFORM_SHAPES,
];

export const MENU: GridShapesMenu = {
  list: [
    {
      title: "Shapes:",
      collapse: true,
      items: [
        ...SHAPES.filter((s: Shape) =>
          ["LargeSquare", "LargeHalflapHorizontal", "SquareFreeform"].includes(
            s.id,
          ),
        ),
        { breakpoint: true },
        ...SHAPES.filter((s: Shape) =>
          [
            "LeftBottomTriangle",
            "Small90LeftBottomTriangle",
            "Quarter",
            "Pixel",
            "HalflapHorizontal",
          ].includes(s.id),
        ),
        { breakpoint: true },
        ...SHAPES.filter((s: Shape) =>
          ["ShiplapHorizontal", "MiniShiplapHorizontal", "Hex"].includes(s.id),
        ),
        { breakpoint: true },
        ...SHAPES.filter((s: Shape) =>
          [
            "LargeDiamond",
            "SmallDiamond",
            "LargeHalfCircleVertical",
            "QuarterCircleBottomLeft",
            "HalfCircleVertical",
            "SmallHalfCircleVertical",
          ].includes(s.id),
        ),
        { breakpoint: true },
        ...SHAPES.filter((s: Shape) =>
          ["LargeTriangleTop", "SmallTriangleTop"].includes(s.id),
        ),
      ],
    },
    {
      title: "Wood Slats:",
      collapse: true,
      items: WOOD_SLAT_FREEFORM_SHAPES,
    },
    {
      title: "Engraved 2' x 2' Tiles:",
      collapse: true,
      items: [
        { sectionSubtitle: "Zen Garden Family:" },
        ...SHAPES.filter((s: Shape) =>
          [
            "EngravedTangentFreeform",
            "EngravedLargeParallelFreeform",
            "EngravedZenFreeform",
          ].includes(s.id),
        ),
        { sectionSubtitle: "Other Tiles:" },
        ...SHAPES.filter((s: Shape) =>
          [
            "EngravedKnotFreeform",
            "EngravedConvergeFreeform",
            "EngravedSubwayFreeform",
            "EngravedOffsetFreeform",
            "EngravedTopoFreeform",
            "EngravedRiverFreeform",
          ].includes(s.id),
        ),
      ],
    },
    {
      title: "Printed 2' x 2' Tiles:",
      collapse: true,
      items: [
        ...SHAPES.filter((s: Shape) =>
          ["AspenFreeform", "BambooFreeform", "GeoFreeform", "PinstripeFreeform", "BlossomFreeform", "StrandFreeform"].includes(s.id),
        ),
      ],
    },
    {
      title: "Dimensional Tiles:",
      collapse: true,
      items: [
        ...SHAPES.filter((s: Shape) =>
          ["LargeUpperPeakFreeform", "LargeCenterPeakFreeform", "SmallPeakFreeform"].includes(s.id),
        ),
      ],
    },
  ],
  default: SHAPES.find((s: Shape) => "SquareFreeform" === s.id),
};

export const findFreeformShapeById = (id: string): Shape | undefined => {
  const searchInShapes = (shapes: Shape[]): Shape | undefined => {
    for (const shape of shapes) {
      if (shape.id === id) return shape;
      if (shape.children?.length) {
        const foundInChildren = searchInShapes(shape.children);
        if (foundInChildren) return foundInChildren;
      }
    }
    return undefined;
  };
  return searchInShapes(SHAPES);
};
